<template>
  <div class="map-wrap">

    <GmapMap
		  :center="{ lat: lat, lng: long }"
      :zoom="zoom"
      ref="map"
      :options="mapOptions"
      @center_changed="updateCenter($event)"      
		>
      <GmapCluster
        :position="{ lat: lat, lng:long }"
        :clickable="true"
        :animation="2"
        :styles="clusterStyles"
        :zoomOnClick="true"
      >
        <GmapMarker
          :key="index"
          v-for="(marker, index) in markers"
          :position="marker.position"
          :clickable="true"
          :draggable="false"
          :label="marker.label"
          :icon="getMarkers(index)"
          @click="toggleInfoWindow(marker.position.id, index)"
        />
      </GmapCluster>
	</GmapMap>

  <InfoWindow
    :infoWindow="infoWindow"
  ></InfoWindow>

  </div>
</template>

<script>
import InfoWindow from './InfoWindow2'

export default {
  props: {
    mapmarkers: Array,
    initmarkers: Array,
    latitude: Number | String,
    longitude: Number | String,
    zoomed: Number
  },

  components: {
    InfoWindow
  },

  data () {
    return {
      selectedKey: null,
      markers: [],
      lat: null,
      long: null,
      zoom: 6,
      clusterStyles: [
        {
          url: '/images/cluster-copy2.png',
          height: 53,
          width: 53,
          textColor: '#FFFFFF',
          textSize: 14
        }
      ],
      mapOptions: {
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUI: false,
        styles: [
          {
            "elementType": "geometry",
            "stylers": [
              { "color": "#f5f5f5" }
            ]
          },
          {
            "elementType": "labels.icon",
            "stylers": [
              { "visibility": "off" }
            ]
          },
          {
            "elementType": "labels.text.fill",
            "stylers": [
              { "color": "#616161" }
            ]
          },
          {
            "elementType": "labels.text.stroke",
            "stylers": [
              { "color": "#f5f5f5" }
            ]
          },
          {
            "featureType": "administrative.land_parcel",
            "elementType": "labels.text.fill",
            "stylers": [
              { "color": "#bdbdbd" }
            ]
          },
          {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
              {  "color": "#eeeeee" }
            ]
          },
          {
            "featureType": "poi",
            "elementType": "labels.text.fill",
            "stylers": [
              { "color": "#757575" }
            ]
          },
          {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [
              { "color": "#e5e5e5" }
            ]
          },
          {
            "featureType": "poi.park",
            "elementType": "labels.text.fill",
            "stylers": [
              { "color": "#9e9e9e" }
            ]
          },
          {
            "featureType": "road",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#ffffff"
              }
            ]
          },
          {
            "featureType": "road.arterial",
            "elementType": "labels.text.fill",
            "stylers": [
              { "color": "#757575" }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "geometry",
            "stylers": [
              { "color": "#dadada" }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "labels.text.fill",
            "stylers": [
              { "color": "#616161" }
            ]
          },
          {
            "featureType": "road.local",
            "elementType": "labels.text.fill",
            "stylers": [
              { "color": "#9e9e9e" }
            ]
          },
          {
            "featureType": "transit.line",
            "elementType": "geometry",
            "stylers": [
              { "color": "#e5e5e5" }
            ]
          },
          {
            "featureType": "transit.station",
            "elementType": "geometry",
            "stylers": [
              { "color": "#eeeeee" }
            ]
          },
          {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
              { "color": "#c9c9c9" }
            ]
          },
          {
            "featureType": "water",
            "elementType": "labels.text.fill",
            "stylers": [
              { "color": "#9e9e9e" }
            ]
          }
        ]
      },
      infoWindow: {
        open: false,
        id: 0,
        title: '',
        url: '',
        address: '',
        phone: '',
        features: []
      },
      mapBounds: {},
      reportedCenter: {}
    }
  },

  mounted () {
    this.lat = parseFloat(this.latitude)
    this.long = parseFloat(this.longitude)
    this.placeMarkers()
  },

  watch: {
    'latitude' () {
      this.lat = parseFloat(this.latitude)
      this.long = parseFloat(this.longitude)
      if (this.zoomed) {
        this.zoom = this.zoomed
      }
      this.placeMarkers()
    }
  },

  methods: {
    fitBounds (bounds) {
      this.$refs.map.fitBounds(bounds);
    },

    truncate (input) {
      if (input.length > 18) {
        return input.substring(0, 18) + '...';
      }
      return input
    },

    placeMarkers () {
      var bounds = new google.maps.LatLngBounds();
      this.markers = [];
      $.each(this.initmarkers, (key, value) => {

          this.markers.push({
            position: {
              lat: parseFloat(value.latitude),
              lng: parseFloat(value.longitude),
              id: value.id
            },
            label: {
              text: this.truncate(value.title),
            //   color: '#FFF',
              color: '#353436',
              fontSize: '12px',
              fontWeight: '600'
            }
          })

          bounds.extend({
            lat: parseFloat(value.latitude),
            lng: parseFloat(value.longitude)
          })

      })

      // this.fitBounds(bounds)
    },

    toggleInfoWindow (id, key) {
      if (this.infoWindow.open) {
        this.closeInfoWindow()
      } else {
        let biz = this.initmarkers.find(obj => obj.id === id)

        this.infoWindow.open = true
        this.infoWindow.id = biz.id
        this.infoWindow.title = biz.title
        this.infoWindow.url = biz.url
        this.infoWindow.address = biz.address
        this.infoWindow.phone = biz.phone
        this.infoWindow.features = biz.features

        this.selectedKey = key
      }
    },    

    closeInfoWindow () {
      this.infoWindow = {
        open: false,
        id: 0,
        title: '',
        url: '',
        address: '',
        phone: '',
        features: []
      }

      this.selectedKey = null
    },

    // dragEnd () {
    //   console.log('dragend', this.$refs.map)
    //   // this.$refs.map.getCenter()
    // },

    updateCenter (event) {

      this.reportedCenter = {
        lat: event.lat(),
        lng: event.lng(),
      }

      this.$emit('draggedLatLong', this.reportedCenter)
    },

    geolocate () {
      this.$store.commit('setLoading', true)

      if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition((position) => {
          this.lat = position.coords.latitude
          this.long = position.coords.longitude
          this.zoom = 12
          this.reportedCenter = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
          }

          this.$store.commit('setLoading', false)
          this.$emit('draggedLatLong', this.reportedCenter)
          })
      } else {
        // Browser doesn't support Geolocation
        handleLocationError(false, infoWindow, map.getCenter());
      }
    },

    getMarkers (key) {
      let icon = { url: '/images/biz-marker.png', scaledSize: { width: 141, height: 51 }, labelOrigin: { x: 70, y: 20 } }
      let active = { url: '/images/biz-marker-active-copy2.png', scaledSize: { width: 141, height: 51 }, labelOrigin: { x: 70, y: 20 } }
      if (this.selectedKey === key) return active
      return icon
    }
  }
}
</script>

<style lang="scss">
@import "../../../sass/core/variables.scss";

.map-wrap {
  position: relative;
  width: 100%;
  height: 513px;

  @media (min-width: $medium) { height: 536px; }
  @media (min-width: $mediumish) { height: 716px; }

  overflow: visible;

  .vue-map-container {
    width: 100%;
    height: 513px;

    font-size: 20px;

    @media (min-width: $medium) { height: 536px; }
    @media (min-width: $mediumish) { height: 716px; }
  }

  &.hide { display: none; }
}
</style>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/locations/Map2.vue